"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.endDateGuardManifest = void 0;
const generated_1 = require("../generated");
const guards_1 = require("../guards");
/**
 * The endDate guard is used to specify a date to end the mint.
 * Any transaction received after the end date will fail.
 */
exports.endDateGuardManifest = {
    name: 'endDate',
    serializer: generated_1.getEndDateSerializer,
    mintParser: guards_1.noopParser,
    routeParser: guards_1.noopParser,
};
//# sourceMappingURL=endDate.js.map